export default __webpack_public_path__ + "static/media/Padron_LondresClosed.3a00447e.jpg";